import React from 'react';

import ContactUsModal from './ContactUsModal';
import ThankYouModal from './ThankYouModal';
import FullSizeImageModal from './FullSizeImageModal';

import { useAppSelector } from '../../store/hooks';
import { selectOpenedModals } from '../../store/selectors/modals';
import { CONTACT_US_MODAL, FULL_SIZE_IMAGE_MODAL, THANK_YOU_MODAL } from '../../constants/modals';

const modalNameToComponent = {
  [CONTACT_US_MODAL]: ContactUsModal,
  [THANK_YOU_MODAL]: ThankYouModal,
  [FULL_SIZE_IMAGE_MODAL]: FullSizeImageModal,
};

interface IModal {
  name: typeof CONTACT_US_MODAL | typeof THANK_YOU_MODAL | typeof FULL_SIZE_IMAGE_MODAL;
  props?: { [key: string]: any };
}

const Modals = () => {
  const modals = useAppSelector(selectOpenedModals);

  return (
    <>
      {/* @ts-ignore */}
      {modals.map(({ name, props }: IModal, key) => {
        const ModalComponent = modalNameToComponent[name];

        //@ts-ignore
        return <ModalComponent {...props} key={key} />;
      })}
    </>
  );
};

export default Modals;
